import React from "react";
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '../css/map-drop-point.css';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { IconContext } from "react-icons";
import { BsLayersHalf } from "react-icons/bs";
import { RiFullscreenFill, RiFullscreenExitFill } from "react-icons/ri";
import Select from 'react-select';
import RecommendationNavBarComponent from "../../components/RecommendationNavBarComponent";
import Chart from 'chart.js/auto';
import { Pie } from 'react-chartjs-2';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useParams } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import ExportExcel from "../../utils/ExportExcel";

import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
const URL = process.env.REACT_APP_URL_SERVER_BACK;
const delay = ms => new Promise(res => setTimeout(res, ms));

let hide1kmTiles = false;
let hide100mTiles = false;
let no_data = false;
let employer = '-';

let filter = '';
let n_employees = 0;
let min_distance_to_station = 0;
let max_distance_to_station = 0;
let kanton = 'all';

let color_1km = 'color'

const _ = require('lodash');

function numberWithCommas(x) {
	if (typeof x !== "undefined") {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
	} else {
		return 0
	}
}

const lines_geojson = {
	'type': 'FeatureCollection',
	'features': [
		{
			'type': 'Feature',
			'geometry': {
				"type": "LineString",
				"coordinates": [
				]
			}
		}
	]
};

//Layer Tyles Selection - Side Menu
class LayerTylesComponent extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			showOptions: false,
			mapa: this.props.map,
		}
		this.hideComponent = this.hideComponent.bind(this);
		this.handleTyleEvent = this.handleTyleEvent.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.map !== prevProps.map) {
			this.setState({ mapa: this.props.map })
		}
	}

	hideComponent(name) {
		this.setState({ showOptions: !this.state.showOptions });
	}

	handleTyleEvent(event) {
		switch (event) {
			case "default":
				this.props.handleTyle("mapbox://styles/mapbox/light-v10");
				break;
			case "outdoors":
				this.props.handleTyle("mapbox://styles/mapbox/outdoors-v11");
				break;
			case "satellite":
				this.props.handleTyle("mapbox://styles/mapbox/satellite-streets-v11");
				break;
			case "streets":
				this.props.handleTyle("mapbox://styles/mapbox/streets-v11");
				break;
			case "dark":
				this.props.handleTyle("mapbox://styles/mapbox/dark-v10");
				break;
			default:
				// eslint-disable-next-line no-unused-expressions
				null;
		}
		this.props.handleCoord(this.state.mapa.getCenter(), this.state.mapa.getZoom());
	}

	render() {
		const { showOptions } = this.state;

		return (
			<div>
				{showOptions ? <>
					<div id='layer-options' className='map-layer-options-tyles'>
						<div className='map-layer-option-dark' onClick={() => this.handleTyleEvent("dark")}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.6em' }}>
								<div>
									<img src={require('../../assets/img/Dark.png')} alt="Default tyle" className='img-tyle' />
								</div>
							</IconContext.Provider>
							<p className='label'>Dark</p>
						</div>
						<div className='map-layer-option-streets' onClick={() => this.handleTyleEvent("streets")}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.6em' }}>
								<div>
									<img src={require('../../assets/img/Streets.png')} alt="Default tyle" className='img-tyle' />
								</div>
							</IconContext.Provider>
							<p className='label'>Streets</p>
						</div>
						<div className='map-layer-option-satellite' onClick={() => this.handleTyleEvent("satellite")}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.6em' }}>
								<div>
									<img src={require('../../assets/img/Satellite.png')} alt="Default tyle" className='img-tyle' />
								</div>
							</IconContext.Provider>
							<p className='label'>Satellite</p>
						</div>
						<div className='map-layer-option-outdoors' onClick={() => this.handleTyleEvent("outdoors")}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.6em' }}>
								<div>
									<img src={require('../../assets/img/Outdoors.png')} alt="Default tyle" className='img-tyle' />
								</div>
							</IconContext.Provider>
							<p className='label'>Outdoors</p>
						</div>
						<div className='map-layer-option-default' onClick={() => this.handleTyleEvent("default")}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.6em' }}>
								<div>
									<img src={require('../../assets/img/White.png')} alt="Default tyle" className='img-tyle' />
								</div>
							</IconContext.Provider>
							<p className='label'>Default</p>
						</div>
					</div>
				</> : <></>}
				<div className='map-layer-tyles'>
					<div className='map-layer-tyles-inner' onClick={() => this.hideComponent("showOptions")}>
						<IconContext.Provider value={{ color: "#5B5B5B", size: '1.8em' }}>
							<div>
								<BsLayersHalf />
							</div>
						</IconContext.Provider>
					</div>
				</div>
			</div>
		)
	}
}

class HideElementsComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			hideNavs: false,
			mapa: this.props.map,
		}
	}

	hideComponent() {
		let newHideNavs = !this.state.hideNavs;
		this.setState({ hideNavs: newHideNavs })
		this.props.updateField("hideNavs", newHideNavs);
	}

	render() {

		const { hideNavs } = this.state;

		return (
			<div>
				{hideNavs ? <>
					<div className='map-close-navs'>
						<div className='map-close-navs-inner' onClick={() => this.hideComponent()}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.8em' }}>
								<div>
									<RiFullscreenExitFill />
								</div>
							</IconContext.Provider>
						</div>
					</div>
				</> : <>
					<div className='map-close-navs'>
						<div className='map-close-navs-inner' onClick={() => this.hideComponent()}>
							<IconContext.Provider value={{ color: "#5B5B5B", size: '1.8em' }}>
								<div>
									<RiFullscreenFill />
								</div>
							</IconContext.Provider>
						</div>
					</div>
				</>}
			</div>
		)
	}
}

class BtnsComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			mapa: this.props.map,
			initial_company: this.props.initial_company,
			generatedTyles1Km: true,
			loading: true,

			total_pkm: 0,
			total_trips: 0,
			current_pkm: 0,
			percentage_pkm: 0,

			distance_min_train_station: 0,
			distance_max_train_station: 5,
			distance_min_buhler: 0,
			distance_max_buhler: 100,
			min_num_trips_per_tile: 0,
			max_num_trips_per_tile: 100000,
			num_changes_ov: 'all',
			num_buses: 5,
			num_capacity: 200,
			convertion_rate: 0.5,
			max_distance_travel: 120,

			cat1_num_changes: 2,
			cat2_num_changes: 2,
			cat3_num_changes: 1,
			lastMileOffer: 'yes',
			cat1_min_percentage: 200,
			cat1_max_percentage: 1000,
			cat2_min_percentage: 130,
			cat2_max_percentage: 200,
			cat3_min_percentage: 0,
			cat3_max_percentage: 130,
			bike_radius: 5000,
			max_min_than_car: 10,

			minutes_in_train: 20,
			current_modal_split_pkm: 0,
			current_modal_split_trips: 0,
			modal_split_green_pkm: 0,
			modal_split_green_trips: 0,
			modal_split_yellow_pkm: 0,
			modal_split_yellow_trips: 0,
			modal_split_red_pkm: 0,
			modal_split_red_trips: 0,
			selectedPKm: 'trips',

			green_cat_bike: 5000,
			yellow_cat_bike: 10000,
			selection_distribution: [false, true, true, true],

			green_pkm: 0,
			green_trips: 0,
			red_pkm: 0,
			red_trips: 0,
			yellow_pkm: 0,
			yellow_trips: 0,
			percentage_pkm_red: 0,
			percentage_pkm_yellow: 0,
			percentage_pkm_green: 0,
			percentage_trips_green: 0,
			percentage_trips_yellow: 0,
			percentage_trips_red: 0,
			current_percentage_pkm_red: 0,
			current_percentage_pkm_yellow: 0,
			current_percentage_pkm_green: 0,
			current_percentage_trips_green: 0,
			current_percentage_trips_yellow: 0,
			current_percentage_trips_red: 0,
			maximum_percentage_difference: 100,

			percentage_pkm_statusquo_green: 0,
			percentage_pkm_statusquo_yellow: 0,
			percentage_pkm_statusquo_red: 0,

			percentage_trips_statusquo_green: 0,
			percentage_trips_statusquo_yellow: 0,
			percentage_trips_statusquo_red: 0,

			data_1km: [],
			showFilters: false,
			table_data: [],
			selected_tile: 0,
			potential_pkm: 0,
			potential_trips: 0,
			num_employees: 0,

			//Total Potential Table
			all_info_total_vs_filter_3d: [],
			potential_pct_total_pkm: 0,
			potential_pct_total_trips: 0,
			potential_total_pkm: 0,
			potential_total_trips: 0,
			total_employees: 0,
			num_hotspots: 0,
			real_total_pkm: 0,
			real_total_trips: 0,
			n_companies: 0,

			total_car_trains_pkm: 0,
			total_car_trains_trips: 0,
			agg_traffic: 'both',
			categories_: this.getCategories(URL + 'tile_potential_employer/categories'),
			current_value_category: {
				label: 'All',
				value: 'all'
			},
			trip_distribution: {},
			loading_potentials: true,

			reli_company: this.props.reli_company,
			show_change_name: false,
			showSucessWindow: false,
			current_company_name: '',
			tile_category_: {
				label: 'Andere',
				value: 'other'
			},
			ExcelExportData: []
		}
		this.handleTilesGenerator()
	}

	componentDidMount() {
		this.handleHide1kmTile = this.handleHide1kmTile.bind(this);
		this.handleHide100mTile = this.handleHide100mTile.bind(this);

		this.handleCat1NumChanges = this.handleCat1NumChanges.bind(this);
		this.handleCat2NumChanges = this.handleCat2NumChanges.bind(this);
		this.handleCat3NumChanges = this.handleCat3NumChanges.bind(this);
		this.handleBikeRadius = this.handleBikeRadius.bind(this);
		this.handleCat1MinPercentage = this.handleCat1MinPercentage.bind(this);
		this.handleCat1MaxPercentage = this.handleCat1MaxPercentage.bind(this);
		this.handleCat2MinPercentage = this.handleCat2MinPercentage.bind(this);
		this.handleCat2MaxPercentage = this.handleCat2MaxPercentage.bind(this);
		this.handleCat3MinPercentage = this.handleCat3MinPercentage.bind(this);
		this.handleCat3MaxPercentage = this.handleCat3MaxPercentage.bind(this);
		this.handleMaxMinutesCar = this.handleMaxMinutesCar.bind(this);
		this.handleTilesGenerator = this.handleTilesGenerator.bind(this);
		this.handleVisualization = this.handleVisualization.bind(this);
		this.handleDistribution = this.handleDistribution.bind(this);

		this.handleGreenCatBike = this.handleGreenCatBike.bind(this);
		this.handleYellowCatBike = this.handleYellowCatBike.bind(this);
		this.handleMinInTrains = this.handleMinInTrains.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.map !== prevProps.map) {
			this.setState({ mapa: this.props.map });
		}
		if (this.props.reli_company !== prevProps.reli_company) {
			if (this.props.reli_company[0] !== 0) {
				this.setState({ show_change_name: true, current_company_name: this.props.reli_company[1] })
			} else {
				this.setState({ show_change_name: false, current_company_name: '' })
			}
			this.setState({ reli_company: this.props.reli_company })
		}
		if (this.props.change_of_background !== prevProps.change_of_background) {
			this.setState({ loading: true })
			this.handle1kmTiles(this.state.distance_min_train_station * 1000, this.state.distance_max_train_station * 1000, this.state.distance_min_buhler * 1000, this.state.distance_max_buhler * 1000, this.state.num_changes_ov, parseInt(this.state.min_num_trips_per_tile), this.state.max_num_trips_per_tile, parseInt(this.state.max_distance_travel), parseInt(this.state.num_buses), parseInt(this.state.num_capacity), parseFloat(this.state.convertion_rate), employer, this.state.maximum_percentage_difference, this.state.selection_distribution)
			this.setState({ loading: false })
		}
	}

	handleCompanyName(event) {
		this.setState({ current_company_name: event.target.value });
	}

	changeCompanyNameOnDB() {
		fetch(URL + 'tile_potential_employer/employers_update_name', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				"RELI": this.props.reli_company[0],
				"company_name": this.state.current_company_name
			})
		}).then(() => {
			fetch(URL + 'tile_potential_employer/employers/' + employer + '/' + filter.slice(filter.lastIndexOf('_') + 1))
				.then((res) => res.json())
				.then((json) => {
					this.props.map.getSource('point').setData(json);
				});
		}).then(async () => {
			this.setState({ showSucessWindow: true })
			await delay(5000);
			this.setState({ showSucessWindow: false, show_change_name: false })
		})

	}

	handleCloseChangeName() {
		this.setState({ show_change_name: false, current_company_name: '' })
		this.props.updateFields({ reli_company: [0, ''] })
	}

	async getCategories(url) {
		const res = await axios.get(url)
		const data = res.data
		let current_selected_category = {};
		data.forEach((category) => {
			if (filter.slice(filter.lastIndexOf('_') + 1) === category.value) {
				current_selected_category = category;
			}
		})

		this.setState({ categories_: data, current_value_category: current_selected_category });

	}

	handleVisualization(event) {
		this.setState({ selectedPKm: event.target.attributes.getNamedItem('id').value })
	}

	demoAsyncCall(min_dist_station, max_dist_station, min_dist_buhler, max_dist_buhler, changes_ov, min_num_trips, max_num_trips, max_distance_travel, num_buses, num_capacity, convertion_rate, maximum_percentage_difference, selection_distribution) {

		let options = []

		if (selection_distribution[0]) {
			options.push('color')
		}
		if (selection_distribution[1]) {
			options.push('color_last_mile')
		}
		if (selection_distribution[2]) {
			options.push('color_bike')
		}
		if (selection_distribution[3]) {
			options.push('color_working')
		}

		const counts = {};
		selection_distribution.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });

		let data;

		let min_trips = ((parseInt(min_num_trips) > 5) ? parseInt(min_num_trips) : 5)
		let body = { employer: this.state.current_employer.value, distance_to_station: [min_dist_station, max_dist_station], distance_to_origin: [min_dist_buhler, max_dist_buhler], changes_in_ov: changes_ov, trips_per_tile: [min_num_trips, max_num_trips], maximum_travel_distance: max_distance_travel, num_buses: num_buses, bus_capacity: num_capacity, conversion_rate: convertion_rate, maximum_percentage_difference: maximum_percentage_difference, options: options }
		let body_1km_colors = { employer: this.state.current_employer.value, distance_to_station: [min_dist_station, max_dist_station], distance_to_origin: [min_dist_buhler, max_dist_buhler], changes_in_ov: changes_ov, trips_per_tile: [min_num_trips, max_num_trips], maximum_travel_distance: max_distance_travel, num_buses: num_buses, bus_capacity: num_capacity, conversion_rate: convertion_rate, last_mile: (this.state.lastMileOffer === 'yes' ? true : false), bike_radius: this.state.bike_radius, threshold_duration_percentage_green: [this.state.cat3_min_percentage, this.state.cat3_max_percentage], threshold_duration_percentage_yellow: [this.state.cat2_min_percentage, this.state.cat2_max_percentage], threshold_duration_percentage_red: [this.state.cat1_min_percentage, this.state.cat1_max_percentage], max_difference_green: this.state.max_min_than_car, max_changes_green: this.state.cat3_num_changes, max_changes_yellow: this.state.cat2_num_changes, min_changes_red: this.state.cat1_num_changes, visited_tiles: [], short_bike_radius: this.state.green_cat_bike, medium_bike_radius: this.state.yellow_cat_bike, minutes_in_train: this.state.minutes_in_train * 60, maximum_percentage_difference: maximum_percentage_difference, options: options, filter: filter }


		let url_1km_tile = 'tile_potential/filter_1km_tiles';
		let url_total_vs_filter = 'tile_potential/total_vs_filter_2d';
		let url_100m_tile = 'tile_potential/100m_tiles';

		fetch(URL + url_total_vs_filter, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body_1km_colors)
		}).then((res) => res.json())
			.then((json) => {
				data = json;
			}).then(() => {
				this.setState({
					total_pkm: numberWithCommas((data.total_pkm).toFixed(0)), total_trips: numberWithCommas((data.total_trips).toFixed(0)), current_pkm: numberWithCommas((data.current_pkm).toFixed(0)), percentage_pkm: (((data.current_pkm / data.total_pkm) * 100).toFixed(0)), data_1km: data,
					current_modal_split_pkm: (data.current_modal_split_pkm * 100).toFixed(0), current_modal_split_trips: (data.current_modal_split_trips * 100).toFixed(0),
					modal_split_green_pkm: (data.modal_split_green_pkm * 100).toFixed(0), modal_split_green_trips: (data.modal_split_green_trips * 100).toFixed(0),
					modal_split_yellow_pkm: (data.modal_split_yellow_pkm * 100).toFixed(0), modal_split_yellow_trips: (data.modal_split_yellow_trips * 100).toFixed(0),
					modal_split_red_pkm: (data.modal_split_red_pkm * 100).toFixed(0), modal_split_red_trips: (data.modal_split_red_trips * 100).toFixed(0),
					potential_trips: data.potential_trips, potential_pkm: data.potential_pkm, num_employees: data.n_employees, n_companies: data.n_companies, trip_distribution: data.trip_distribution
				});


				if (counts.true === 1 && this.state.selection_distribution[0]) {
					this.setState({
						green_pkm: ((data.green_pkm).toFixed(0)), green_trips: ((data.green_trips).toFixed(0)), red_pkm: ((data.red_pkm).toFixed(0)), red_trips: ((data.red_trips).toFixed(0)), yellow_pkm: ((data.yellow_pkm).toFixed(0)), yellow_trips: ((data.yellow_trips).toFixed(0)),
						percentage_pkm_green: (((data.green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.red_pkm / data.current_pkm) * 100).toFixed(0)),
						percentage_trips_green: (((data.green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.yellow_trips / data.current_trips) * 100).toFixed(0))
					});
				}
				else if (counts.true === 1 && this.state.selection_distribution[2]) {
					this.setState({
						green_pkm: ((data.bike_green_pkm).toFixed(0)), green_trips: ((data.bike_green_trips).toFixed(0)), red_pkm: ((data.bike_red_pkm).toFixed(0)), red_trips: ((data.bike_red_trips).toFixed(0)), yellow_pkm: ((data.bike_yellow_pkm).toFixed(0)), yellow_trips: ((data.bike_yellow_trips).toFixed(0)),
						percentage_pkm_green: (((data.bike_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.bike_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.bike_red_pkm / data.current_pkm) * 100).toFixed(0)),
						percentage_trips_green: (((data.bike_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.bike_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.bike_yellow_trips / data.current_trips) * 100).toFixed(0))
					});
				}
				else if (counts.true === 1 && this.state.selection_distribution[1]) {
					this.setState({
						green_pkm: ((data.last_mile_green_pkm).toFixed(0)), green_trips: ((data.last_mile_green_trips).toFixed(0)), red_pkm: ((data.last_mile_red_pkm).toFixed(0)), red_trips: ((data.last_mile_red_trips).toFixed(0)), yellow_pkm: ((data.last_mile_yellow_pkm).toFixed(0)), yellow_trips: ((data.last_mile_yellow_trips).toFixed(0)),
						percentage_pkm_green: (((data.last_mile_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.last_mile_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.last_mile_red_pkm / data.current_pkm) * 100).toFixed(0)),
						percentage_trips_green: (((data.last_mile_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.last_mile_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.last_mile_yellow_trips / data.current_trips) * 100).toFixed(0))
					});
				}
				else if (counts.true === 1 && this.state.selection_distribution[3]) {
					this.setState({
						green_pkm: ((data.working_green_pkm).toFixed(0)), green_trips: ((data.working_green_trips).toFixed(0)), red_pkm: ((data.working_red_pkm).toFixed(0)), red_trips: ((data.working_red_trips).toFixed(0)), yellow_pkm: ((data.working_yellow_pkm).toFixed(0)), yellow_trips: ((data.working_yellow_trips).toFixed(0)),
						percentage_pkm_green: (((data.working_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.working_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.working_red_pkm / data.current_pkm) * 100).toFixed(0)),
						percentage_trips_green: (((data.working_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.working_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.working_yellow_trips / data.current_trips) * 100).toFixed(0))
					});
				}
				else if (counts.true > 1) {
					this.setState({
						green_pkm: ((data.combined_green_pkm).toFixed(0)), green_trips: ((data.combined_green_trips).toFixed(0)), red_pkm: ((data.combined_red_pkm).toFixed(0)), red_trips: ((data.combined_red_trips).toFixed(0)), yellow_pkm: ((data.combined_yellow_pkm).toFixed(0)), yellow_trips: ((data.combined_yellow_trips).toFixed(0)),
						percentage_pkm_green: (((data.combined_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.combined_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.combined_red_pkm / data.current_pkm) * 100).toFixed(0)),
						percentage_trips_green: (((data.combined_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.combined_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.combined_yellow_trips / data.current_trips) * 100).toFixed(0))
					});
				}

			})
			.then(() => {

				fetch(URL + url_100m_tile, {
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(body)
				})
					.then((res) => res.json())
					.then((json) => {
						data = json;
					}).then(() => { this.state.mapa.getSource('data-swiss-100m-tile').setData(data) })
					.then(() => {
						fetch(URL + url_1km_tile, {
							method: 'POST',
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
							},
							body: JSON.stringify(body_1km_colors)
						})
							.then((res) => res.json())
							.then((json) => {
								data = json;
							}).then(() => {
								this.state.mapa.getSource('data-swiss-1km-tile').setData(data)
								this.props.map.setPaintProperty('swiss-1km-tile', 'fill-color', ['get', color_1km]);
								this.props.map.setPaintProperty('outline-swiss-1km-tile', 'line-color', ['get', color_1km]);
							})
					})
					.then(() => {
						this.props.map.setLayoutProperty('swiss-1km-tile', 'visibility', 'visible');
						this.props.map.setLayoutProperty('outline-swiss-1km-tile', 'visibility', 'visible');
						this.props.map.setLayoutProperty('swiss-100m-tile', 'visibility', 'visible');
						this.props.map.setLayoutProperty('outline-swiss-100m-tile', 'visibility', 'visible');
					})
					.then(() => {
						fetch(URL + url_total_vs_filter, {
							method: 'POST',
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
							},
							body: JSON.stringify(body_1km_colors)
						}).then((res) => res.json())
							.then((json) => {
								data = json;
							}).then(() => {

								this.setState({
									total_pkm: numberWithCommas((data.total_pkm).toFixed(0)), total_trips: numberWithCommas((data.total_trips).toFixed(0)), current_pkm: numberWithCommas((data.current_pkm).toFixed(0)), percentage_pkm: (((data.current_pkm / data.total_pkm) * 100).toFixed(0)), data_1km: data,
									current_modal_split_pkm: (data.current_modal_split_pkm * 100).toFixed(0), current_modal_split_trips: (data.current_modal_split_trips * 100).toFixed(0),
									modal_split_green_pkm: (data.modal_split_green_pkm * 100).toFixed(0), modal_split_green_trips: (data.modal_split_green_trips * 100).toFixed(0),
									modal_split_yellow_pkm: (data.modal_split_yellow_pkm * 100).toFixed(0), modal_split_yellow_trips: (data.modal_split_yellow_trips * 100).toFixed(0),
									modal_split_red_pkm: (data.modal_split_red_pkm * 100).toFixed(0), modal_split_red_trips: (data.modal_split_red_trips * 100).toFixed(0),
									potential_trips: data.potential_trips, potential_pkm: data.potential_pkm, num_employees: data.n_employees, n_companies: data.n_companies, trip_distribution: data.trip_distribution
								});

								if (counts.true === 1 && this.state.selection_distribution[0]) {
									this.setState({
										green_pkm: ((data.green_pkm).toFixed(0)), green_trips: ((data.green_trips).toFixed(0)), red_pkm: ((data.red_pkm).toFixed(0)), red_trips: ((data.red_trips).toFixed(0)), yellow_pkm: ((data.yellow_pkm).toFixed(0)), yellow_trips: ((data.yellow_trips).toFixed(0)),
										current_percentage_pkm_green: (((data.green_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data.yellow_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data.red_pkm / data.current_pkm) * 100).toFixed(0)),
										current_percentage_trips_green: (((data.green_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data.red_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data.yellow_trips / data.current_trips) * 100).toFixed(0))
									});
								}
								else if (counts.true === 1 && this.state.selection_distribution[2]) {
									this.setState({
										green_pkm: ((data.bike_green_pkm).toFixed(0)), green_trips: ((data.bike_green_trips).toFixed(0)), red_pkm: ((data.bike_red_pkm).toFixed(0)), red_trips: ((data.bike_red_trips).toFixed(0)), yellow_pkm: ((data.bike_yellow_pkm).toFixed(0)), yellow_trips: ((data.bike_yellow_trips).toFixed(0)),
										current_percentage_pkm_green: (((data.bike_green_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data.bike_yellow_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data.bike_red_pkm / data.current_pkm) * 100).toFixed(0)),
										current_percentage_trips_green: (((data.bike_green_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data.bike_red_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data.bike_yellow_trips / data.current_trips) * 100).toFixed(0))
									});
								}
								else if (counts.true === 1 && this.state.selection_distribution[1]) {
									this.setState({
										green_pkm: ((data.last_mile_green_pkm).toFixed(0)), green_trips: ((data.last_mile_green_trips).toFixed(0)), red_pkm: ((data.last_mile_red_pkm).toFixed(0)), red_trips: ((data.last_mile_red_trips).toFixed(0)), yellow_pkm: ((data.last_mile_yellow_pkm).toFixed(0)), yellow_trips: ((data.last_mile_yellow_trips).toFixed(0)),
										current_percentage_pkm_green: (((data.last_mile_green_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data.last_mile_yellow_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data.last_mile_red_pkm / data.current_pkm) * 100).toFixed(0)),
										current_percentage_trips_green: (((data.last_mile_green_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data.last_mile_red_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data.last_mile_yellow_trips / data.current_trips) * 100).toFixed(0))
									});
								}
								else if (counts.true === 1 && this.state.selection_distribution[3]) {
									this.setState({
										green_pkm: ((data.working_green_pkm).toFixed(0)), green_trips: ((data.working_green_trips).toFixed(0)), red_pkm: ((data.working_red_pkm).toFixed(0)), red_trips: ((data.working_red_trips).toFixed(0)), yellow_pkm: ((data.working_yellow_pkm).toFixed(0)), yellow_trips: ((data.working_yellow_trips).toFixed(0)),
										current_percentage_pkm_green: (((data.working_green_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data.working_yellow_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data.working_red_pkm / data.current_pkm) * 100).toFixed(0)),
										current_percentage_trips_green: (((data.working_green_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data.working_red_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data.working_yellow_trips / data.current_trips) * 100).toFixed(0))
									});
								} else if (counts.true > 1) {
									this.setState({
										green_pkm: ((data.combined_green_pkm).toFixed(0)), green_trips: ((data.combined_green_trips).toFixed(0)), red_pkm: ((data.combined_red_pkm).toFixed(0)), red_trips: ((data.combined_red_trips).toFixed(0)), yellow_pkm: ((data.combined_yellow_pkm).toFixed(0)), yellow_trips: ((data.combined_yellow_trips).toFixed(0)),
										current_percentage_pkm_green: (((data.combined_green_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data.combined_yellow_pkm / data.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data.combined_red_pkm / data.current_pkm) * 100).toFixed(0)),
										current_percentage_trips_green: (((data.combined_green_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data.combined_red_trips / data.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data.combined_yellow_trips / data.current_trips) * 100).toFixed(0))
									});
								}

							}).then(() => { this.setState({ loading: false, generatedBusRoute: true, generatedTyles1Km: false }) });
					})
			})
	}

	getExcel(json){
		let all=[]
		console.log(json.features)
		if (json.length !== 0 || json.length !== 'undefined') {
			json = json.features
            for (var i = 0; i < json.length; i++) {
                all.push({
					"TileID": json[i].properties.tileId,
                    "URL": 'https://www.ov42.com/tile/'+ json[i].properties.tileId,
                    "Duration by car":json[i].properties.duration_car_text,
                    "Duration by train":json[i].properties.duration_train_text,
                    "Bike Trips Weekdays Tiles": json[i].properties.bike_trips_weekdays_tiles,
					"Bus Trips Weekdays Tiles": json[i].properties.bus_trips_weekdays_tiles,
                    "Car Trips Weekdays Tiles": json[i].properties.car_trips_weekdays_tiles,
                    "Walking Trips Weekdays Tiles": json[i].properties.foot_trips_weekdays_tiles,
                    "Mortorbike Trips Weekdays Tiles": json[i].properties.motorbike_trips_weekdays_tiles,
                    "Train Trips Weekdays Tiles": json[i].properties.train_trips_weekdays_tiles,
                    "Tram Trips Weekdays Tiles": json[i].properties.tram_trips_weekdays_tiles,
                    "UBahn Trips Weekdays Tiles": json[i].properties.ubahn_trips_weekdays_tiles,
                    "Total Trips Weekdays Tiles": json[i].properties.total_trips_weekdays_tiles,
                })
			}
		}
console.log(all)
this.setState({ExcelExportData: all})
	}


	handle1kmTiles(min_dist_station, max_dist_station, min_dist_buhler, max_dist_buhler, changes_ov, min_num_trips, max_num_trips, max_distance_travel, num_buses, num_capacity, convertion_rate, employer, maximum_percentage_difference, selection_distribution) {

		let url_1km_tile = 'tile_potential/filter_1km_tiles';
		let url_total_vs_filter = 'tile_potential/total_vs_filter_2d';
		let url_100m_tile = 'tile_potential/100m_tiles';

		let options = []

		if (selection_distribution[0]) {
			options.push('color')
		}
		if (selection_distribution[1]) {
			options.push('color_last_mile')
		}
		if (selection_distribution[2]) {
			options.push('color_bike')
		}
		if (selection_distribution[3]) {
			options.push('color_working')
		}

		const counts = {};
		selection_distribution.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });

		let data;
		let body = { origin: employer, distance_to_station: [min_dist_station, max_dist_station], distance_to_origin: [min_dist_buhler, max_dist_buhler], changes_in_ov: changes_ov, trips_per_tile: [min_num_trips, max_num_trips], maximum_travel_distance: max_distance_travel, num_buses: num_buses, bus_capacity: num_capacity, conversion_rate: convertion_rate, maximum_percentage_difference: maximum_percentage_difference, options: options }
		let body_1km_colors = { origin: employer, distance_to_station: [min_dist_station, max_dist_station], distance_to_origin: [min_dist_buhler, max_dist_buhler], changes_in_ov: changes_ov, trips_per_tile: [min_num_trips, max_num_trips], maximum_travel_distance: max_distance_travel, num_buses: num_buses, bus_capacity: num_capacity, conversion_rate: convertion_rate, last_mile: (this.state.lastMileOffer === 'yes' ? true : false), bike_radius: this.state.bike_radius, threshold_duration_percentage_green: [this.state.cat3_min_percentage, this.state.cat3_max_percentage], threshold_duration_percentage_yellow: [this.state.cat2_min_percentage, this.state.cat2_max_percentage], threshold_duration_percentage_red: [this.state.cat1_min_percentage, this.state.cat1_max_percentage], max_difference_green: this.state.max_min_than_car, max_changes_green: this.state.cat3_num_changes, max_changes_yellow: this.state.cat2_num_changes, min_changes_red: this.state.cat1_num_changes, visited_tiles: [], short_bike_radius: this.state.green_cat_bike, medium_bike_radius: this.state.yellow_cat_bike, minutes_in_train: this.state.minutes_in_train * 60, maximum_percentage_difference: maximum_percentage_difference, options: options, filter: filter }

		fetch(URL + url_1km_tile, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body_1km_colors)
		})
			.then((res) => res.json())
			.then((json) => {
				data = json;
				this.getExcel(json);
			}).then(async () => {
				await delay(5000);
				this.props.map.getSource('data-swiss-1km-tile').setData(data);
				this.props.map.setPaintProperty('swiss-1km-tile', 'fill-color', ['get', color_1km]);
				this.props.map.setPaintProperty('outline-swiss-1km-tile', 'line-color', ['get', color_1km]);
			})
			.then(() => {
				fetch(URL + url_total_vs_filter, {
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(body_1km_colors)
				}).then((res) => res.json())
					.then((json) => {
						data = json;
					}).then(() => {
						this.setState({
							total_pkm: numberWithCommas((data.total_pkm).toFixed(0)), total_trips: numberWithCommas((data.total_trips).toFixed(0)), current_pkm: numberWithCommas((data.current_pkm).toFixed(0)), percentage_pkm: (((data.current_pkm / data.total_pkm) * 100).toFixed(0)), data_1km: data,
							current_modal_split_pkm: (data.current_modal_split_pkm * 100).toFixed(0), current_modal_split_trips: (data.current_modal_split_trips * 100).toFixed(0),
							modal_split_green_pkm: (data.modal_split_green_pkm * 100).toFixed(0), modal_split_green_trips: (data.modal_split_green_trips * 100).toFixed(0),
							modal_split_yellow_pkm: (data.modal_split_yellow_pkm * 100).toFixed(0), modal_split_yellow_trips: (data.modal_split_yellow_trips * 100).toFixed(0),
							modal_split_red_pkm: (data.modal_split_red_pkm * 100).toFixed(0), modal_split_red_trips: (data.modal_split_red_trips * 100).toFixed(0),
							potential_trips: data.potential_trips, potential_pkm: data.potential_pkm, num_employees: data.n_employees, n_companies: data.n_companies, trip_distribution: data.trip_distribution
						});

						this.setState({
							percentage_pkm_statusquo_green: (((data.green_pkm / data.current_pkm) * 100).toFixed(0)),
							percentage_pkm_statusquo_yellow: (((data.yellow_pkm / data.current_pkm) * 100).toFixed(0)),
							percentage_pkm_statusquo_red: (((data.red_pkm / data.current_pkm) * 100).toFixed(0)),

							percentage_trips_statusquo_green: (((data.green_trips / data.current_trips) * 100).toFixed(0)),
							percentage_trips_statusquo_yellow: (((data.yellow_trips / data.current_trips) * 100).toFixed(0)),
							percentage_trips_statusquo_red: (((data.red_trips / data.current_trips) * 100).toFixed(0))
						});

						if (counts.true === 1 && this.state.selection_distribution[0]) {

							this.setState({
								green_pkm: ((data.green_pkm).toFixed(0)), green_trips: ((data.green_trips).toFixed(0)), red_pkm: ((data.red_pkm).toFixed(0)), red_trips: ((data.red_trips).toFixed(0)), yellow_pkm: ((data.yellow_pkm).toFixed(0)), yellow_trips: ((data.yellow_trips).toFixed(0)),
								percentage_pkm_green: (((data.green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.red_pkm / data.current_pkm) * 100).toFixed(0)),
								percentage_trips_green: (((data.green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.yellow_trips / data.current_trips) * 100).toFixed(0))
							});
							color_1km = 'color'
						}
						else if (counts.true === 1 && this.state.selection_distribution[2]) {
							this.setState({
								green_pkm: ((data.bike_green_pkm).toFixed(0)), green_trips: ((data.bike_green_trips).toFixed(0)), red_pkm: ((data.bike_red_pkm).toFixed(0)), red_trips: ((data.bike_red_trips).toFixed(0)), yellow_pkm: ((data.bike_yellow_pkm).toFixed(0)), yellow_trips: ((data.bike_yellow_trips).toFixed(0)),
								percentage_pkm_green: (((data.bike_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.bike_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.bike_red_pkm / data.current_pkm) * 100).toFixed(0)),
								percentage_trips_green: (((data.bike_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.bike_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.bike_yellow_trips / data.current_trips) * 100).toFixed(0))
							});
							color_1km = 'color_bike'
						}
						else if (counts.true === 1 && this.state.selection_distribution[1]) {
							this.setState({
								green_pkm: ((data.last_mile_green_pkm).toFixed(0)), green_trips: ((data.last_mile_green_trips).toFixed(0)), red_pkm: ((data.last_mile_red_pkm).toFixed(0)), red_trips: ((data.last_mile_red_trips).toFixed(0)), yellow_pkm: ((data.last_mile_yellow_pkm).toFixed(0)), yellow_trips: ((data.last_mile_yellow_trips).toFixed(0)),
								percentage_pkm_green: (((data.last_mile_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.last_mile_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.last_mile_red_pkm / data.current_pkm) * 100).toFixed(0)),
								percentage_trips_green: (((data.last_mile_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.last_mile_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.last_mile_yellow_trips / data.current_trips) * 100).toFixed(0))
							});
							color_1km = 'color_last_mile'
						}
						else if (counts.true === 1 && this.state.selection_distribution[3]) {
							this.setState({
								green_pkm: ((data.working_green_pkm).toFixed(0)), green_trips: ((data.working_green_trips).toFixed(0)), red_pkm: ((data.working_red_pkm).toFixed(0)), red_trips: ((data.working_red_trips).toFixed(0)), yellow_pkm: ((data.working_yellow_pkm).toFixed(0)), yellow_trips: ((data.working_yellow_trips).toFixed(0)),
								percentage_pkm_green: (((data.working_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.working_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.working_red_pkm / data.current_pkm) * 100).toFixed(0)),
								percentage_trips_green: (((data.working_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.working_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.working_yellow_trips / data.current_trips) * 100).toFixed(0))
							});
							color_1km = 'color_working'
						}
						else if (counts.true > 1) {
							this.setState({
								green_pkm: ((data.combined_green_pkm).toFixed(0)), green_trips: ((data.combined_green_trips).toFixed(0)), red_pkm: ((data.combined_red_pkm).toFixed(0)), red_trips: ((data.combined_red_trips).toFixed(0)), yellow_pkm: ((data.combined_yellow_pkm).toFixed(0)), yellow_trips: ((data.combined_yellow_trips).toFixed(0)),
								percentage_pkm_green: (((data.combined_green_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_yellow: (((data.combined_yellow_pkm / data.current_pkm) * 100).toFixed(0)), percentage_pkm_red: (((data.combined_red_pkm / data.current_pkm) * 100).toFixed(0)),
								percentage_trips_green: (((data.combined_green_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_red: (((data.combined_red_trips / data.current_trips) * 100).toFixed(0)), percentage_trips_yellow: (((data.combined_yellow_trips / data.current_trips) * 100).toFixed(0))
							});
							color_1km = 'color_combined'
						}

						this.props.map.setPaintProperty('swiss-1km-tile', 'fill-color', ['get', color_1km]);
						this.props.map.setPaintProperty('outline-swiss-1km-tile', 'line-color', ['get', color_1km]);
					})
					.then(() => { this.setState({ loading: false }) })
					.then(() => {
						fetch(URL + 'tile_potential_employer/employers/' + employer + '/' + filter.slice(filter.lastIndexOf('_') + 1))
							.then((res) => res.json())
							.then((json) => {
								this.props.map.getSource('point').setData(json);
							})
					}
					)
			})
			.then(() => {
				fetch(URL + url_100m_tile, {
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(body)
				})
					.then((res) => res.json())
					.then((json) => {
						data = json;
					}).then(() => {
						this.state.mapa.getSource('data-swiss-100m-tile').setData(data);
					})
			})
			.then(() => {
				this.state.mapa.setLayoutProperty('swiss-1km-tile', 'visibility', 'visible');
				this.state.mapa.setLayoutProperty('outline-swiss-1km-tile', 'visibility', 'visible');
				this.state.mapa.setLayoutProperty('swiss-1km-tile-labels', 'visibility', 'visible');
				this.props.map.setLayoutProperty('swiss-100m-tile', 'visibility', 'visible');
				this.props.map.setLayoutProperty('outline-swiss-100m-tile', 'visibility', 'visible');
				this.setState({ generatedBusRoute: false })
			})
	}

	handleNewTileGenerator() {
		this.setState({ loading: true });

		employer = parseInt(this.state.selected_tile);
		this.handle1kmTiles(this.state.distance_min_train_station * 1000, this.state.distance_max_train_station * 1000, this.state.distance_min_buhler * 1000, this.state.distance_max_buhler * 1000, this.state.num_changes_ov, parseInt(this.state.min_num_trips_per_tile), this.state.max_num_trips_per_tile, parseInt(this.state.max_distance_travel), parseInt(this.state.num_buses), parseInt(this.state.num_capacity), parseFloat(this.state.convertion_rate), employer, this.state.maximum_percentage_difference, this.state.selection_distribution);
		this.setState({ selected_tile: 0 });
		this.state.mapa.getSource('data-selected-tile').setData(lines_geojson);
	}

	handleTilesGenerator() {
		this.setState({ loading: true });

		let params = this.state.initial_company['*'].split(',')
		employer = parseInt(params[0]);
		filter = params[1];
		n_employees = parseInt(params[2]);

		min_distance_to_station = parseInt(params[3]);
		max_distance_to_station = parseInt(params[4]);
		kanton = params[5];

		this.handle1kmTiles(this.state.distance_min_train_station * 1000, this.state.distance_max_train_station * 1000, this.state.distance_min_buhler * 1000, this.state.distance_max_buhler * 1000, this.state.num_changes_ov, parseInt(this.state.min_num_trips_per_tile), this.state.max_num_trips_per_tile, parseInt(this.state.max_distance_travel), parseInt(this.state.num_buses), parseInt(this.state.num_capacity), parseFloat(this.state.convertion_rate), employer, this.state.maximum_percentage_difference, this.state.selection_distribution)

		this.handleTable(filter, n_employees, min_distance_to_station, max_distance_to_station, kanton);

		this.setState({ generatedTyles1Km: true });
		hide1kmTiles = false;
		this.setState({ loading: false });
	}

	handleTilesGeneratorBtn() {
		this.setState({ loading: true });

		let params = this.state.initial_company['*'].split(',')
		filter = params[1];
		n_employees = parseInt(params[2]);
		min_distance_to_station = parseInt(params[3]);
		max_distance_to_station = parseInt(params[4]);
		kanton = params[5];

		this.handle1kmTiles(this.state.distance_min_train_station * 1000, this.state.distance_max_train_station * 1000, this.state.distance_min_buhler * 1000, this.state.distance_max_buhler * 1000, this.state.num_changes_ov, parseInt(this.state.min_num_trips_per_tile), this.state.max_num_trips_per_tile, parseInt(this.state.max_distance_travel), parseInt(this.state.num_buses), parseInt(this.state.num_capacity), parseFloat(this.state.convertion_rate), employer, this.state.maximum_percentage_difference, this.state.selection_distribution)

		this.handleTable(filter, n_employees, min_distance_to_station, max_distance_to_station, kanton);

		this.setState({ generatedTyles1Km: true });
		hide1kmTiles = false;
	}

	handleTable(filter, n_employees, min_distance_to_station, max_distance_to_station, kanton) {
		this.setState({ loading_potentials: true })
		fetch(URL + 'tile_potential_employer/' + filter + '/' + n_employees + '/' + min_distance_to_station + ',' + max_distance_to_station + '/' + kanton + '/top_employer_list')
			.then((res) => res.json())
			.then((json) => {
				this.setState({ table_data: json });
			}).then(() => {
				fetch(URL + 'tile_potential_employer/0/' + filter + '/trips/' + n_employees + '/' + min_distance_to_station + ',' + max_distance_to_station + '/behavior,last_mile,bike,working,car_pooling/' + kanton + '/total_vs_filter_3d_optimized')
					.then((res) => res.json())
					.then((json) => {
						this.setState({
							all_info_total_vs_filter_3d: json,

							potential_pct_total_pkm: (json.current_behavior_pkm + json.current_bike_pkm + json.current_last_mile_pkm + json.current_working_pkm + json.current_car_pooling_pkm) / json.total_pkm * 100,
							potential_pct_total_trips: (json.current_behavior_trips + json.current_bike_trips + json.current_last_mile_trips + json.current_working_trips + json.current_car_pooling_trips) / json.total_trips * 100,
							potential_total_pkm: (json.current_behavior_pkm + json.current_bike_pkm + json.current_last_mile_pkm + json.current_working_pkm + json.current_car_pooling_pkm),
							potential_total_trips: (json.current_behavior_trips + json.current_bike_trips + json.current_last_mile_trips + json.current_working_trips + json.current_car_pooling_trips),
							total_employees: json.total_employees,
							num_hotspots: json.total_tiles,
							real_total_pkm: json.total_pkm.toFixed(0),
							real_total_trips: json.total_trips.toFixed(0),
							total_car_trains_pkm: json.total_car_trains_pkm,
							total_car_trains_trips: json.total_car_trains_trips,
						});
					}).then(() => {
						this.setState({ loading_potentials: false })
					})
			})
	}

	handleHide1kmTile() {
		let temp = !hide1kmTiles;
		hide1kmTiles = temp;
		if (temp) {
			this.state.mapa.setLayoutProperty('swiss-1km-tile', 'visibility', 'none');
			this.state.mapa.setLayoutProperty('outline-swiss-1km-tile', 'visibility', 'none');
			this.state.mapa.setLayoutProperty('swiss-1km-tile-labels', 'visibility', 'none');
		}
		else {
			this.state.mapa.setLayoutProperty('swiss-1km-tile', 'visibility', 'visible');
			this.state.mapa.setLayoutProperty('outline-swiss-1km-tile', 'visibility', 'visible');
			this.state.mapa.setLayoutProperty('swiss-1km-tile-labels', 'visibility', 'visible');
		}
	}

	handleHide100mTile() {
		let temp = !hide100mTiles;
		hide100mTiles = temp;
		if (temp) {
			this.state.mapa.setLayoutProperty('swiss-100m-tile', 'visibility', 'none');
			this.state.mapa.setLayoutProperty('outline-swiss-100m-tile', 'visibility', 'none');
		}
		else {
			this.state.mapa.setLayoutProperty('outline-swiss-100m-tile', 'visibility', 'visible');
			this.state.mapa.setLayoutProperty('swiss-100m-tile', 'visibility', 'visible');
		}
	}

	handleMaxMinutesCar(event) {
		this.setState({ max_min_than_car: Number(event.target.value) })
	}

	handleBikeRadius(event) {
		this.setState({ bike_radius: Number(event.target.value) });
	}

	handleCat1NumChanges(event) {
		this.setState({ cat1_num_changes: Number(event.target.value) })
	}

	handleCat2NumChanges(event) {
		this.setState({ cat2_num_changes: Number(event.target.value) })
	}

	handleCat3NumChanges(event) {
		this.setState({ cat3_num_changes: Number(event.target.value) })
	}

	handleCat1MinPercentage(event) {
		this.setState({ cat1_min_percentage: Number(event.target.value) })
	}

	handleCat1MaxPercentage(event) {
		this.setState({ cat1_max_percentage: Number(event.target.value) })
	}

	handleCat2MinPercentage(event) {
		this.setState({ cat2_min_percentage: Number(event.target.value) })
	}

	handleGreenCatBike(event) {
		this.setState({ green_cat_bike: Number(event.target.value) })
	}

	handleMinInTrains(event) {
		this.setState({ minutes_in_train: Number(event.target.value) })
	}

	handleYellowCatBike(event) {
		this.setState({ yellow_cat_bike: Number(event.target.value) })
	}

	handleCat2MaxPercentage(event) {
		this.setState({ cat2_max_percentage: Number(event.target.value) })
	}

	handleCat3MinPercentage(event) {
		this.setState({ cat3_min_percentage: Number(event.target.value) })
	}

	handleCat3MaxPercentage(event) {
		this.setState({ cat3_max_percentage: Number(event.target.value) })
	}

	handleConvertionRate(event) {
		this.setState({ convertion_rate: event.target.value })
	}

	handleMaxDistanceTravel(event) {
		this.setState({ max_distance_travel: Number(event.target.value) })
	}

	handleDistribution(event) {

		let current_selection_distribution = this.state.selection_distribution;

		if (event.target.attributes.getNamedItem('id').value === 'general') {
			current_selection_distribution[0] = (!current_selection_distribution[0])

			if (current_selection_distribution[0]) {
				current_selection_distribution = [true, false, false, false]
			} else {
				current_selection_distribution = [false, true, true, true]
			}

		} else if (event.target.attributes.getNamedItem('id').value === 'lastmile') {
			current_selection_distribution[1] = (!current_selection_distribution[1])
		} else if (event.target.attributes.getNamedItem('id').value === 'bike') {
			current_selection_distribution[2] = (!current_selection_distribution[2])
		} else if (event.target.attributes.getNamedItem('id').value === 'working') {
			current_selection_distribution[3] = (!current_selection_distribution[3])
		}

		const counts = {};
		current_selection_distribution.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
		this.setState({ selection_distribution: current_selection_distribution })

		let data_bus = this.state.data_bus;

		if (this.state.generatedBusRoute) {
			if (counts.true === 1 && current_selection_distribution[0]) {
				this.setState({
					green_pkm: ((data_bus.green_pkm).toFixed(0)), green_trips: ((data_bus.green_trips).toFixed(0)), red_pkm: ((data_bus.red_pkm).toFixed(0)), red_trips: ((data_bus.red_trips).toFixed(0)), yellow_pkm: ((data_bus.yellow_pkm).toFixed(0)), yellow_trips: ((data_bus.yellow_trips).toFixed(0)),
					current_percentage_pkm_green: (((data_bus.green_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data_bus.yellow_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data_bus.red_pkm / data_bus.current_pkm) * 100).toFixed(0)),
					current_percentage_trips_green: (((data_bus.green_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data_bus.red_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data_bus.yellow_trips / data_bus.current_trips) * 100).toFixed(0))
				});
			}
			else if (counts.true === 1 && current_selection_distribution[2]) {
				this.setState({
					green_pkm: ((data_bus.bike_green_pkm).toFixed(0)), green_trips: ((data_bus.bike_green_trips).toFixed(0)), red_pkm: ((data_bus.bike_red_pkm).toFixed(0)), red_trips: ((data_bus.bike_red_trips).toFixed(0)), yellow_pkm: ((data_bus.bike_yellow_pkm).toFixed(0)), yellow_trips: ((data_bus.bike_yellow_trips).toFixed(0)),
					current_percentage_pkm_green: (((data_bus.bike_green_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data_bus.bike_yellow_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data_bus.bike_red_pkm / data_bus.current_pkm) * 100).toFixed(0)),
					current_percentage_trips_green: (((data_bus.bike_green_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data_bus.bike_red_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data_bus.bike_yellow_trips / data_bus.current_trips) * 100).toFixed(0))
				});
			}
			else if (counts.true === 1 && current_selection_distribution[1]) {
				this.setState({
					green_pkm: ((data_bus.last_mile_green_pkm).toFixed(0)), green_trips: ((data_bus.last_mile_green_trips).toFixed(0)), red_pkm: ((data_bus.last_mile_red_pkm).toFixed(0)), red_trips: ((data_bus.last_mile_red_trips).toFixed(0)), yellow_pkm: ((data_bus.last_mile_yellow_pkm).toFixed(0)), yellow_trips: ((data_bus.last_mile_yellow_trips).toFixed(0)),
					current_percentage_pkm_green: (((data_bus.last_mile_green_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data_bus.last_mile_yellow_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data_bus.last_mile_red_pkm / data_bus.current_pkm) * 100).toFixed(0)),
					current_percentage_trips_green: (((data_bus.last_mile_green_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data_bus.last_mile_red_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data_bus.last_mile_yellow_trips / data_bus.current_trips) * 100).toFixed(0))
				});
			}
			else if (counts.true === 1 && current_selection_distribution[3]) {
				this.setState({
					green_pkm: ((data_bus.working_green_pkm).toFixed(0)), green_trips: ((data_bus.working_green_trips).toFixed(0)), red_pkm: ((data_bus.working_red_pkm).toFixed(0)), red_trips: ((data_bus.working_red_trips).toFixed(0)), yellow_pkm: ((data_bus.working_yellow_pkm).toFixed(0)), yellow_trips: ((data_bus.working_yellow_trips).toFixed(0)),
					current_percentage_pkm_green: (((data_bus.working_green_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data_bus.working_yellow_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data_bus.working_red_pkm / data_bus.current_pkm) * 100).toFixed(0)),
					current_percentage_trips_green: (((data_bus.working_green_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data_bus.working_red_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data_bus.working_yellow_trips / data_bus.current_trips) * 100).toFixed(0))
				});
			}
			else if (counts.true > 1) {
				this.setState({
					green_pkm: ((data_bus.combined_green_pkm).toFixed(0)), green_trips: ((data_bus.combined_green_trips).toFixed(0)), red_pkm: ((data_bus.combined_red_pkm).toFixed(0)), red_trips: ((data_bus.combined_red_trips).toFixed(0)), yellow_pkm: ((data_bus.combined_yellow_pkm).toFixed(0)), yellow_trips: ((data_bus.combined_yellow_trips).toFixed(0)),
					current_percentage_pkm_green: (((data_bus.combined_green_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_yellow: (((data_bus.combined_yellow_pkm / data_bus.current_pkm) * 100).toFixed(0)), current_percentage_pkm_red: (((data_bus.combined_red_pkm / data_bus.current_pkm) * 100).toFixed(0)),
					current_percentage_trips_green: (((data_bus.combined_green_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_red: (((data_bus.combined_red_trips / data_bus.current_trips) * 100).toFixed(0)), current_percentage_trips_yellow: (((data_bus.combined_yellow_trips / data_bus.current_trips) * 100).toFixed(0))
				});
			}
		} else {
			this.setState({ loading: true });
			this.handle1kmTiles(this.state.distance_min_train_station * 1000, this.state.distance_max_train_station * 1000, this.state.distance_min_buhler * 1000, this.state.distance_max_buhler * 1000, this.state.num_changes_ov, parseInt(this.state.min_num_trips_per_tile), this.state.max_num_trips_per_tile, parseInt(this.state.max_distance_travel), parseInt(this.state.num_buses), parseInt(this.state.num_capacity), parseFloat(this.state.convertion_rate), parseInt(employer), this.state.maximum_percentage_difference, current_selection_distribution)
			this.handleTable(filter, n_employees, min_distance_to_station, max_distance_to_station, kanton);
			this.setState({ generatedTyles1Km: true });
			hide1kmTiles = false;
		}
	}

	handleMaxPercentageDifference(event) {
		this.setState({ maximum_percentage_difference: event });
	}

	hideComponentFilter() {
		this.setState({ showFilters: !this.state.showFilters });
	}

	highlightTile(tile) {
		this.setState({ selected_tile: tile })

		fetch(URL + 'areas_to_focus/tile/' + tile)
			.then((res) => res.json())
			.then((json) => {
				const tyle_corner = {
					center: [((json.features[0].geometry.coordinates[0][1][0] + json.features[0].geometry.coordinates[0][2][0]) / 2), ((json.features[0].geometry.coordinates[0][2][1] + json.features[0].geometry.coordinates[0][3][1]) / 2)],
					zoom: 14.5,
					pitch: 0,
					bearing: 0
				}

				this.props.map.flyTo({
					...tyle_corner, // Fly to the selected target
					duration: 2000, // Animate over 2 seconds
					essential: false // This animation is considered essential with
					//respect to prefers-reduced-motion
				})

				this.props.map.getSource('data-selected-tile').setData(json);
			})


	}

	handleBuildingCategory(event) {
		this.setState({ current_value_category: event, loading: true });

		filter = filter.slice(0, filter.lastIndexOf('_')) + '_' + event.value;
		this.handleTable(filter, n_employees, min_distance_to_station, max_distance_to_station, kanton);

		fetch(URL + 'tile_potential_employer/employers/' + employer + '/' + event.value)
			.then((res) => res.json())
			.then((json) => {
				this.props.map.getSource('point').setData(json);
			}).then(() => {
				this.setState({ loading: false })
			})

	}

	render() {
		const { loading } = this.state;
		const { generatedTyles1Km } = this.state;
		const { current_pkm } = this.state;
		const { total_pkm } = this.state;
		const { percentage_pkm } = this.state;

		const { percentage_pkm_red } = this.state;
		const { percentage_pkm_yellow } = this.state;
		const { percentage_pkm_green } = this.state;
		const { percentage_trips_red } = this.state;
		const { percentage_trips_yellow } = this.state;
		const { percentage_trips_green } = this.state;
		const { current_percentage_pkm_red } = this.state;
		const { current_percentage_pkm_yellow } = this.state;
		const { current_percentage_pkm_green } = this.state;
		const { current_percentage_trips_red } = this.state;
		const { current_percentage_trips_yellow } = this.state;
		const { current_percentage_trips_green } = this.state;

		const { red_pkm } = this.state;
		const { green_pkm } = this.state;
		const { yellow_pkm } = this.state;

		const { green_trips } = this.state;
		const { red_trips } = this.state;
		const { yellow_trips } = this.state;

		const { selectedPKm } = this.state;
		const { selection_distribution } = this.state;

		const { percentage_pkm_statusquo_green } = this.state;
		const { percentage_pkm_statusquo_yellow } = this.state;
		const { percentage_pkm_statusquo_red } = this.state;

		const { percentage_trips_statusquo_green } = this.state;
		const { percentage_trips_statusquo_yellow } = this.state;
		const { percentage_trips_statusquo_red } = this.state;

		const data_sex = {
			labels: ['Employees', 'Ausbildung', 'Heime', 'Hotel', 'Kinos', 'Museen / Events', 'Andere', 'Spitäler', 'Einkaufen', 'Bahnhof'],
			datasets: [
				{
					data: [
						this.state.trip_distribution['trips_employees'],
						this.state.trip_distribution['trips_ausbildung'],
						this.state.trip_distribution['trips_heime'],
						this.state.trip_distribution['trips_hotel'],
						this.state.trip_distribution['trips_kinos'],
						this.state.trip_distribution['trips_museen'],
						this.state.trip_distribution['trips_other'],
						this.state.trip_distribution['trips_gesundheit'],
						this.state.trip_distribution['trips_einkaufen'],
						this.state.trip_distribution['trips_bahnhof'],
					],
					backgroundColor: [
						'rgba(251, 86, 7, 0.2)',
						'rgba(255, 192, 19, 0.2)',
						'rgba(131, 56, 236, 0.2)',
						'rgba(58, 134, 255, 0.2)',
						'rgba(255, 0, 110, 0.2)',
						'rgba(3, 13, 201, 0.2)',
						'rgba(3, 188, 0, 0.2)',
						'rgba(227, 6, 6, 0.2)',
						'rgba(39, 204, 179, 0.2)',
					],
					borderColor: [
						'rgba(251, 86, 7, 1)',
						'rgba(255, 192, 19, 1)',
						'rgba(131, 56, 236, 1)',
						'rgba(58, 134, 255, 1)',
						'rgba(255, 0, 110, 1)',
						'rgba(3, 13, 201, 1)',
						'rgba(3, 188, 0, 1)',
						'rgba(227, 6, 6, 1)',
						'rgba(39, 204, 179, 1)',
					],
					borderWidth: 1.2,
				},
			],
		};

		const selectStyles = {
			menuList: styles => {
				return {
					...styles,
					maxHeight: 150
				};
			}
		};

		const listEmployers = this.state.table_data?.map((tile, index) =>
			<tr key={index} onClick={() => this.highlightTile(tile.tileId)} style={{ backgroundColor: (tile.tileId === employer ? '#FFDBEE' : (tile.tileId === this.state.selected_tile ? '#DBE5FF' : '#FFFFFF')) }}>
				<td className="table-data-regional-od">{index + 1}</td>
				<td className="table-data-regional-od">{(tile['max_name_' + this.state.current_value_category.value] === null ? '-' : tile['max_name_' + this.state.current_value_category.value])}</td>
				<td className="table-data-regional-od">{tile.name}</td>
				<td className="table-data-regional-od">{numberWithCommas(tile['absolute_employeers']?.toFixed(0))}</td>
				<td className="table-data-regional-od">{numberWithCommas(tile['absolute_category']?.toFixed(0))}</td>
				<td className="table-data-regional-od">{numberWithCommas((tile['absolute_employeers'] + tile['absolute_category'])?.toFixed(0))}</td>
			</tr>
		);

		const options = {
			maintainAspectRatio: false
		};

		if (loading) { // if your component doesn't have to wait for an async action, remove this block 
			return (
				<div className="bg-loader">
					<div className="pos-center-brain-loader">
						<div className="circle-loading-brain">
						</div>
						<svg className='brain-loader' x="0px" y="0px" viewBox="0 0 496 496">
							<path d="M40,449.472V364.28L58.424,352H88v-16H53.576L24,355.72v93.752C14.704,452.784,8,461.584,8,472c0,13.232,10.768,24,24,24				s24-10.768,24-24C56,461.584,49.288,452.784,40,449.472z M32,480c-4.416,0-8-3.584-8-8c0-4.416,3.584-8,8-8s8,3.584,8,8				C40,476.416,36.416,480,32,480z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M46.528,320H88v-16H46.528c-3.312-9.288-12.112-16-22.528-16c-13.232,0-24,10.768-24,24s10.768,24,24,24				C34.416,336,43.216,329.288,46.528,320z M16,312c0-4.416,3.584-8,8-8s8,3.584,8,8c0,4.416-3.584,8-8,8S16,316.416,16,312z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M24,272c10.416,0,19.216-6.712,22.528-16H88v-16H46.528c-3.312-9.296-12.112-16-22.528-16c-13.232,0-24,10.768-24,24				S10.768,272,24,272z M24,240c4.416,0,8,3.584,8,8s-3.584,8-8,8s-8-3.584-8-8C16,243.584,19.584,240,24,240z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M56 272h32v16H56Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M56 208h32v16H56Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M0 176h88v16H0Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M60.688,160H88v-16H67.312L48,124.688v-14.16C57.288,107.216,64,98.416,64,88c0-13.232-10.768-24-24-24S16,74.768,16,88				c0,10.416,6.704,19.216,16,22.528v20.784L60.688,160z M40,80c4.416,0,8,3.584,8,8s-3.584,8-8,8s-8-3.584-8-8S35.584,80,40,80z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M144 67.312L144 88L160 88L160 60.688L131.312 32L0 32L0 48L124.688 48z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M176 35.312L176 88L192 88L192 28.688L163.312 0L0 0L0 16L156.688 16z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M208 56h16v32H208Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M304 0h16v88H304Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M240,46.528V88h16V59.312l16,16V88h16V68.688L262.392,43.08C268.192,38.696,272,31.816,272,24c0-13.232-10.768-24-24-24				s-24,10.768-24,24C224,34.416,230.704,43.216,240,46.528z M248,16c4.416,0,8,3.584,8,8s-3.584,8-8,8s-8-3.584-8-8				S243.584,16,248,16z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M352,51.312L371.312,32h78.16c2.416,6.776,7.752,12.112,14.528,14.528v110.16L444.688,176H408v16h43.312L480,163.312				V46.528c9.288-3.312,16-12.112,16-22.528c0-13.232-10.768-24-24-24c-10.416,0-19.216,6.712-22.528,16h-84.784L336,44.688V88h16				V51.312z M472,16c4.416,0,8,3.584,8,8s-3.584,8-8,8c-4.416,0-8-3.584-8-8S467.584,16,472,16z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M414.08,97.392l17.92,17.92v9.376L412.688,144H408v16h11.312L448,131.312v-22.624L419.312,80h-4.784				c-3.312-9.288-12.112-16-22.528-16c-13.232,0-24,10.768-24,24s10.768,24,24,24C401.904,112,410.416,105.968,414.08,97.392z				 M392,96c-4.416,0-8-3.584-8-8s3.584-8,8-8c4.416,0,8,3.584,8,8S396.416,96,392,96z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M408 208h88v16H408Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M480,449.472V268.688L451.312,240H408v16h36.688L464,275.312v41.376L451.312,304H408v16h36.688L464,339.312v110.16				c-9.296,3.312-16,12.112-16,22.528c0,13.232,10.768,24,24,24s24-10.768,24-24C496,461.584,489.288,452.784,480,449.472z M472,480				c-4.416,0-8-3.584-8-8c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C480,476.416,476.416,480,472,480z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M408 272h32v16H408Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M448,364.688L419.312,336H408v16h4.688L432,371.312V416h-80v-8h-16v24h96v12.688L412.688,464h-14.16				c-3.312-9.288-12.112-16-22.528-16c-13.232,0-24,10.768-24,24s10.768,24,24,24c10.416,0,19.216-6.712,22.528-16h20.784				L448,451.312V364.688z M376,480c-4.416,0-8-3.584-8-8c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C384,476.416,380.416,480,376,480z				" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M160,408h-16v8h-41.472c-3.312-9.288-12.112-16-22.528-16c-13.232,0-24,10.768-24,24s10.768,24,24,24				c10.416,0,19.216-6.712,22.528-16H160V408z M80,432c-4.416,0-8-3.584-8-8c0-4.416,3.584-8,8-8s8,3.584,8,8				C88,428.416,84.416,432,80,432z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M304 408h16v88H304Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M272 408h16v88H272Z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M240,420.688l-16,16V408h-16v41.472c-9.296,3.312-16,12.112-16,22.528c0,13.232,10.768,24,24,24s24-10.768,24-24				c0-7.816-3.808-14.696-9.608-19.08L256,427.312V408h-16V420.688z M216,480c-4.416,0-8-3.584-8-8c0-4.416,3.584-8,8-8s8,3.584,8,8				C224,476.416,220.416,480,216,480z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M192 408L176 408L176 428.688L152 452.688L152 496L168 496L168 459.312L192 435.312z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M336,392h16v-16h24v-24h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-16v-16h16				v-16h-16v-24h-24v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-3.312				L120,140.688V144h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h16v24h24v16h16v-16h16				v16h16v-16h16v16h16v-16h16v16h16v-16h16v16h16v-16h16v16h16v-16h16V392z M136,360V147.312L147.312,136H360v224H136z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M318.888,211.048l13.96-13.96l-33.936-33.936l-13.96,13.96c-4.16-2.184-8.488-3.976-12.952-5.384V152h-48v19.728				c-4.472,1.408-8.8,3.2-12.952,5.384l-13.96-13.96l-33.936,33.936l13.96,13.96c-2.176,4.16-3.976,8.488-5.384,12.952H152v48				h19.728c1.408,4.472,3.2,8.8,5.384,12.952l-13.96,13.96l33.936,33.936l13.96-13.96c4.16,2.176,8.48,3.976,12.952,5.384V344h48				v-19.728c4.472-1.408,8.8-3.2,12.952-5.384l13.96,13.96l33.936-33.936l-13.96-13.96c2.176-4.152,3.976-8.48,5.384-12.952H344v-48				h-19.728C322.864,219.528,321.072,215.2,318.888,211.048z M328,256h-16.224l-1.416,6.224c-1.6,7.016-4.368,13.672-8.216,19.792				l-3.408,5.408l11.496,11.496l-11.312,11.312l-11.496-11.496l-5.408,3.408c-6.12,3.848-12.776,6.616-19.792,8.216L256,311.776V328				h-16v-16.224l-6.224-1.416c-7.016-1.6-13.672-4.368-19.792-8.216l-5.408-3.408l-11.496,11.496l-11.312-11.312l11.496-11.496				l-3.408-5.408c-3.848-6.12-6.616-12.776-8.216-19.792L184.224,256H168v-16h16.224l1.416-6.224				c1.6-7.016,4.368-13.672,8.216-19.792l3.408-5.408l-11.496-11.496l11.312-11.312l11.496,11.488l5.408-3.408				c6.12-3.848,12.776-6.616,19.792-8.216l6.224-1.408V168h16v16.224l6.224,1.416c7.016,1.6,13.672,4.368,19.792,8.216l5.408,3.408				l11.496-11.488l11.312,11.312l-11.496,11.496l3.408,5.408c3.848,6.12,6.616,12.776,8.216,19.792l1.416,6.216H328V256z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M248,208c-22.056,0-40,17.944-40,40c0,22.056,17.944,40,40,40c22.056,0,40-17.944,40-40C288,225.944,270.056,208,248,208				z M248,272c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S261.232,272,248,272z" fill="white" stroke="#e32a8d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
				</div>
			)
		}
		else {
			return (
				<div>
					{this.state.show_change_name ?
						<>
							<div className="modal-potential-change-name-companies">
								<div className="modal-potential-change-name-companies-inner">
									<div className="row" style={{ justifyItems: 'end', height: '1.2em' }}>
										<div className="column-2-10">
											<div style={{ width: '1.2em' }} onClick={this.handleCloseChangeName.bind(this)}>
												<IconContext.Provider value={{ color: "#5B5B5B", size: '1em' }}>
													<div>
														<RxCross2 />
													</div>
												</IconContext.Provider>
											</div>
										</div>
										<div className="column-1-90">
											<h1>Change Company Information</h1>
										</div>
									</div>
									<h1 style={{ justifyItems: 'left', fontWeight: 500, fontSize: '12px' }}>Name of the company</h1>
									<div className="row" style={{ justifyItems: 'center', height: '1.5em' }}>
										<input type="text" style={{ width: '90%' }} value={this.state.current_company_name} onChange={this.handleCompanyName.bind(this)} />
									</div>
									{/* <h1 style={{justifyItems: 'left', fontWeight: 500, fontSize: '12px'}}>Category</h1>
									<div className="row" style={{ justifyItems: 'center', height: '1.5em' }}>
									<Select className='categories' placeholder="Category" isClearable={false} options={this.state.categories_} onChange={this.handleBuildingCategory.bind(this)} styles={selectStyles} value={this.state.tile_category_} />
									</div> */}
									<div className="row" style={{ justifyItems: 'end', paddingTop: '5px', paddingBottom: '5px' }}>
										<Form onClick={this.changeCompanyNameOnDB.bind(this)}>
											<Button className="generate-btn" variant="info">Update</Button>
										</Form>
									</div>
								</div>
							</div>
							{this.state.showSucessWindow ?
								<>
									<div className="map-success-assigned-category" style={{ left: '0', top: '595px' }}>
										<div className="map-success-assigned-category-inner">
											<h2>Company name has been assigned successfully!</h2>
										</div>
									</div>
								</>
								: <></>}
						</>
						:
						<></>}
					<div className="tile-category-div" style={{ left: '280px' }}>
						<Select className='categories' placeholder="Filter by Building Category..." isClearable={false} options={this.state.categories_} onChange={this.handleBuildingCategory.bind(this)} styles={selectStyles} value={this.state.current_value_category} />
					</div>
					<div className="modal-potential-employer-tile-table">
						<div className="modal-potential-employer-tile-table-inner">
							<Tabs defaultActiveKey="top_table"
								id="uncontrolled-tab-example"
								className="mb-3">
								<Tab eventKey="top_table" title="Top Hotspots based on Employers">
									<h1>Top Hotspots based on Employers</h1>
									<h3><b>Distance to train station: </b>Between {numberWithCommas(min_distance_to_station)}m and {numberWithCommas(max_distance_to_station)}m
										<br /> {n_employees > 0 ? 'Minimun number of employees:' + numberWithCommas(n_employees.toString()) : 'No minimun employees filter activated'}
										<br /> {filter === 'sum' ? 'Based on all tile employers\' data' : 'Based on tile\'s main employer\'s data'}
									</h3>
									<div className="top-tiles-employer-scroll">
										<table className="top-od-regional">
											<thead>
												<tr key='headers'>
													<th className="table-title-regional-od">#</th>
													<th className="table-title-regional-od">Company name</th>
													<th className="table-title-regional-od">Place</th>
													<th className="table-title-regional-od">Potential Employees</th>
													<th className="table-title-regional-od">Potential Visitors</th>
													<th className="table-title-regional-od">Total</th>
												</tr>
											</thead>
											<tbody>
												{listEmployers}
											</tbody>
										</table>
									</div>
									<Form onClick={this.handleNewTileGenerator.bind(this)}>
										<Button className="generate-btn" variant="info" disabled={this.state.selected_tile === 0}>Evaluate selected tile</Button>
									</Form>
								</Tab>
								<Tab eventKey="pie_chart" title="Category Distribution">
									<h1>Companies' Distribution within the Tile</h1>
									<div style={{ height: '350px' }}>
										<Pie data={data_sex} options={options} />
									</div>
								</Tab>

							</Tabs>
						</div>
					</div>
					{generatedTyles1Km ?
						<>
							<div className="map-b2b-modal-split" style={{ top: "590px", paddingBottom: '0px' }}>
								<div className="map-b2b-modal-split-inner" style={{ padding: "5px", height: '60px', width: '465px', paddingBottom: '0px' }}>
									<div className="row">
										{this.state.potential_pkm !== null ?
											<>
												<h1 style={{ fontWeight: '500', fontSize: '14px', marginBottom: '0px' }}>{numberWithCommas(this.state.data_1km.trip_distribution.trips_employees?.toFixed(0))} trips generated by {numberWithCommas(this.state.num_employees)} employees in {numberWithCommas(this.state.n_companies)} companies</h1>
												<h1 style={{ fontWeight: '500', fontSize: '14px', marginBottom: '0px' }}>{numberWithCommas((this.state.current_value_category.value === 'all' ? (this.state.data_1km.trip_distribution.trips_ausbildung + this.state.data_1km.trip_distribution.trips_heime +
													this.state.data_1km.trip_distribution.trips_hotel + this.state.data_1km.trip_distribution.trips_kinos + this.state.data_1km.trip_distribution.trips_museen +
													this.state.data_1km.trip_distribution.trips_einkaufen + this.state.data_1km.trip_distribution.trips_bahnhof + this.state.data_1km.trip_distribution.trips_other) : (this.state.data_1km.trip_distribution['trips_' + this.state.current_value_category.value])).toFixed(0))} trips generated by visitors/leisure</h1>
												<h1 style={{ fontWeight: '700', fontSize: '12px', marginBottom: '0px' }}>{((selectedPKm === 'pkm') ? numberWithCommas(this.state.data_1km.potential_pkm.toFixed(0)) + ' PKm' : numberWithCommas(this.state.data_1km.potential_trips.toFixed(0)) + ' trips')} potential of {((selectedPKm === 'pkm') ? this.state.total_pkm + ' PKm' : this.state.total_trips + ' trips')} in total for the tile</h1>
											</>
											:
											<h1 style={{ fontWeight: '600', fontSize: '14px', paddingTop: '8px' }}>No potential calculation available</h1>
										}
									</div>
								</div>
							</div>

							<div className="map-potential-btn-tile-potential2D-resp-1" style={{ left: "160px", top: "230px" }}>
								<div className="map-btn-tile-potential2D-resp-1-inner" style={{ height: "70px", width: "300px" }}>
									<div className="row-parameters-3">
										<h4>Trips with a great car alternative</h4>
										<div style={{height: '20px', paddingTop: '10px'}}>
											<div className="column-1-eq"><h4 style={{ fontSize: "25px", fontWeight: '800' }}>{((selection_distribution[0] === true && selection_distribution[1] === false
										&& selection_distribution[2] === false && selection_distribution[3] === false)?((selectedPKm === 'pkm') ? this.state.percentage_pkm_green : this.state.percentage_trips_green):((selectedPKm === 'pkm') ? this.state.percentage_pkm_statusquo_green : this.state.percentage_trips_statusquo_green))}%</h4></div>
											<div className="column-2-eq"><h4 style={{ fontSize: "25px", textAlign: 'right', fontWeight: '800' }}>{((selection_distribution[0] === true && selection_distribution[1] === false
										&& selection_distribution[2] === false && selection_distribution[3] === false)?('0'):((selectedPKm === 'pkm') ? this.state.percentage_pkm_green-this.state.percentage_pkm_statusquo_green : this.state.percentage_trips_green-this.state.percentage_trips_statusquo_green))}%</h4></div>
										</div>
										<div class="miniBar" style={{height: '15px', backgroundColor: '#E7F6F1',}}>
											<div class="miniBarProgress1" style={{backgroundColor: '#158D62', width: ((selection_distribution[0] === true && selection_distribution[1] === false
										&& selection_distribution[2] === false && selection_distribution[3] === false)?((selectedPKm === 'pkm') ? this.state.percentage_pkm_green : this.state.percentage_trips_green):((selectedPKm === 'pkm') ? this.state.percentage_pkm_statusquo_green : this.state.percentage_trips_statusquo_green))+"%"}}></div>
										<div class="miniBarProgress2" style={{backgroundColor: '#00BD50', left: ((selection_distribution[0] === true && selection_distribution[1] === false
										&& selection_distribution[2] === false && selection_distribution[3] === false)?((selectedPKm === 'pkm') ? this.state.percentage_pkm_green : this.state.percentage_trips_green):((selectedPKm === 'pkm') ? this.state.percentage_pkm_statusquo_green : this.state.percentage_trips_statusquo_green))+"%", 
										width: ((selection_distribution[0] === true && selection_distribution[1] === false
											&& selection_distribution[2] === false && selection_distribution[3] === false)? 0 :((selectedPKm === 'pkm') ? this.state.percentage_pkm_green-this.state.percentage_pkm_statusquo_green : this.state.percentage_trips_green-this.state.percentage_trips_statusquo_green))+"%"}}></div>
										
										</div>
										<div>
											<div className="column-1-eq"><h4 style={{ fontSize: "9px" }}>Status Quo</h4></div>
											<div className="column-2-eq"><h4 style={{ fontSize: "9px", textAlign: 'right' }}>Simulated Potential</h4></div>
										</div>
									</div>
								</div>
							</div>
							<div className="map-potential-btn-tile-potential2D-resp-1" style={{ left: "160px", top: "330px" }}>
								<div className="map-btn-tile-potential2D-resp-1-inner" style={{ height: "50px", width: "300px" }}>
									<div className="row-parameters-3">
										<h4>Out of the {(selectedPKm === 'pkm' ? percentage_pkm_green : percentage_trips_green)}% {(selectedPKm === 'pkm' ? 'PKms' : 'trips')} with a great car alternative</h4>
										<div  style={{height: '15px'}}>
											<div className="column-1-eq"><h4 style={{ fontSize: "15px", fontWeight: '800' }}>{((selectedPKm === 'pkm') ? this.state.modal_split_green_pkm : this.state.modal_split_green_trips)}%</h4></div>
											<div className="column-2-eq"><h4 style={{ fontSize: "15px", textAlign: 'right', fontWeight: '800' }}>{((selectedPKm === 'pkm') ? 100 - this.state.modal_split_green_pkm : 100 - this.state.modal_split_green_trips)}%</h4></div>
										</div>
										<div class="miniBar" style={{height: '10px'}}>
											<div class="miniBarProgress1" style={{width: ((selectedPKm === 'pkm') ? this.state.modal_split_green_pkm : this.state.modal_split_green_trips)+"%"}}></div>
										</div>
										<div>
											<div className="column-1-eq"><h4 style={{ fontSize: "9px" }}>are already car-free</h4></div>
											<div className="column-2-eq"><h4 style={{ fontSize: "9px", textAlign: 'right' }}>are still car-based</h4></div>
										</div>
									</div>
								</div>
							</div>
							<div className="map-data-from-employers" style={{ top: "535px" }}>
								<div className="map-data-from-inner">
									<div className="row">
										<p>Data computed based on Swisscom and own routing algorithm</p>
									</div>
								</div>
							</div>
							<div className="map-potential-total-filtered-value" style={{ top: 575 + 'px', right: '0px' }}>
								<div className="map-potential-total-filtered-value-inner" style={{ width: '460px', height: 'auto', marginBottom: '0px' }}>
									{this.state.loading_potentials ?
										<div className="data_insights_loader" style={{ padding: '5%', paddingLeft: '40%' }}>
											<div className="loader"></div>
										</div>
										: <>
											<h3 style={{ marginBottom: '0px', fontSize: '11.5px' }}>Potentials of {numberWithCommas(this.state.total_employees)} employees in {numberWithCommas(this.state.num_hotspots)} hotspots in {numberWithCommas(this.state.all_info_total_vs_filter_3d['total_companies'])} companies</h3>
											<table className="top-od-regional" style={{ paddingTop: "0px", width: '450px' }}>
												<thead>
													<tr key='headers'>
														<th className="table-title-regional-od">Measures</th>
														<th className="table-title-regional-od">{(selectedPKm === 'pkm' ? 'Passenger Km' : 'Number of trips')}</th>
														<th className="table-title-regional-od">Percentage</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td className="table-data-regional-od">
															{/* <div className="square" style={{ backgroundColor: "#390099" }}></div> */}
															Behaviour
														</td>
														<td className="table-data-regional-od">
															{
																(numberWithCommas(this.state.all_info_total_vs_filter_3d['current_behavior_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]?.toFixed(0)))
															}
														</td>
														<td className="table-data-regional-od">
															{
																(this.state.all_info_total_vs_filter_3d['current_behavior_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)] / this.state['real_total_' + selectedPKm] * 100)?.toFixed(1) + '%'
															}
														</td>
													</tr>
													<tr>
														<td className="table-data-regional-od">
															{/* <div className="square" style={{ backgroundColor: "#390099" }}></div> */}
															Bike
														</td>
														<td className="table-data-regional-od">
															{
																((numberWithCommas(this.state.all_info_total_vs_filter_3d['current_bike_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]?.toFixed(0))))
															}
														</td>
														<td className="table-data-regional-od">
															{
																(this.state.all_info_total_vs_filter_3d['current_bike_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)] / this.state['real_total_' + selectedPKm] * 100)?.toFixed(1) + '%'
															}
														</td>
													</tr>
													<tr>
														<td className="table-data-regional-od">
															{/* <div className="square" style={{ backgroundColor: "#390099" }}></div> */}
															Last Mile
														</td>
														<td className="table-data-regional-od">
															{
																((numberWithCommas(this.state.all_info_total_vs_filter_3d['current_last_mile_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]?.toFixed(0))))
															}
														</td>
														<td className="table-data-regional-od">
															{
																(this.state.all_info_total_vs_filter_3d['current_last_mile_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)] / this.state['real_total_' + selectedPKm] * 100)?.toFixed(1) + '%'
															}
														</td>
													</tr>
													<tr>
														<td className="table-data-regional-od">
															{/* <div className="square" style={{ backgroundColor: "#390099" }}></div> */}
															Working Time
														</td>
														<td className="table-data-regional-od">
															{
																((numberWithCommas(this.state.all_info_total_vs_filter_3d['current_working_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]?.toFixed(0))))
															}

														</td>
														<td className="table-data-regional-od">
															{
																(this.state.all_info_total_vs_filter_3d['current_working_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)] / this.state['real_total_' + selectedPKm] * 100)?.toFixed(1) + '%'
															}
														</td>
													</tr>
													<tr>
														<td className="table-data-regional-od">
															{/* <div className="square" style={{ backgroundColor: "#390099" }}></div> */}
															Car Pooling
														</td>
														<td className="table-data-regional-od">
															{
																((numberWithCommas(this.state.all_info_total_vs_filter_3d['current_car_pooling_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]?.toFixed(0))))
															}
														</td>
														<td className="table-data-regional-od">
															{
																(this.state.all_info_total_vs_filter_3d['current_car_pooling_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)] / this.state['real_total_' + selectedPKm] * 100)?.toFixed(1) + '%'
															}
														</td>
													</tr>
												</tbody>
											</table>
											<hr className="table-separation" />
											<table className="top-od-regional" style={{ paddingTop: "0px", width: '450px' }}>
												<thead>
													<tr key='headers'>
														<th className="table-title-regional-od">Total Commuting</th>
														<td className="table-data-regional-od">{(numberWithCommas(this.state.all_info_total_vs_filter_3d['current_potential_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]?.toFixed(0)))}
															{(selectedPKm === 'pkm' ? ' Pkm' : ' trips')}</td>

														<td className="table-data-regional-od">
															{(this.state.all_info_total_vs_filter_3d['current_potential_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)] / this.state['real_total_' + selectedPKm] * 100).toFixed(1)}%
														</td>

													</tr>

													{this.state.agg_traffic === 'both' || this.state.agg_traffic === 'employeers'
														?
														<>
															<tr>
																<td className="table-data-regional-od">
																	{/* <div className="square" style={{ backgroundColor: "#390099" }}></div> */}
																	Leisure
																</td>
																<td className="table-data-regional-od">
																	{(numberWithCommas(this.state.all_info_total_vs_filter_3d['current_leisure_' + selectedPKm]?.toFixed(0)))}
																	{(selectedPKm === 'pkm' ? ' Pkm' : ' trips')}
																</td>
																<td className="table-data-regional-od">
																	{(this.state.all_info_total_vs_filter_3d['current_leisure_' + selectedPKm] / this.state['real_total_' + selectedPKm] * 100).toFixed(1)}%

																</td>
															</tr>

															<tr key='headers-total-especial'>
																<th className="table-title-regional-od">Total with Leisure</th>
																<td className="table-data-regional-od">
																	{numberWithCommas((this.state.all_info_total_vs_filter_3d['current_leisure_' + selectedPKm] + this.state.all_info_total_vs_filter_3d['current_potential_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]).toFixed(0))}
																	{(selectedPKm === 'pkm' ? ' Pkm' : ' trips')}
																</td>
																<td className="table-data-regional-od">
																	{((this.state.all_info_total_vs_filter_3d['current_leisure_' + selectedPKm] + this.state.all_info_total_vs_filter_3d['current_potential_' + selectedPKm + (this.state.agg_traffic === 'both' ? '' : '_' + this.state.agg_traffic)]) / this.state['real_total_' + selectedPKm] * 100).toFixed(1)}%
																</td>
															</tr></>
														:
														<>
															<>
															</>
														</>
													}
												</thead>
											</table>
											<ExportExcel excelData={this.state.ExcelExportData} fileName={'Switzerland - 5in5 - Excel Export'} />
										</>}

								</div>
							</div>
							<div className="map-potential-btn-drop-point-info-display" style={{ top: "90px" }}>
								<div className="map-potential-btn-drop-point-info-display-inner">
									<h2>Visualize contribution percentage by</h2>
									<Form onChange={this.handleVisualization.bind(this)}>
										<div className="row">
											<div className="column-1-eq">
												<Form.Check inline label=" Passenger Km" name="type_analysis" type='radio' id='pkm' defaultChecked={(selectedPKm === 'pkm')} />
											</div>
											<div className="column-2-eq">
												<Form.Check inline label=" Number of Trips" name="type_analysis" type='radio' id='trips' defaultChecked={(selectedPKm === 'trips')} />
											</div>
										</div>
									</Form>
								</div>
							</div>
							<div className="map-potential-btn-drop-point-info-category" style={{ top: "160px" }}>
								<div className="map-potential-btn-drop-point-info-category-inner">
									<h2>Simulate Green Mobility Potential</h2>
									<Form onChange={this.handleDistribution.bind(this)}>
										<div className="row">
											<div className="column-headquarters-2">
												<Form.Check inline label="Status Quo" name="type_analysis" type='checkbox' id='general' defaultChecked={(selection_distribution[0])} />
											</div>
											<div className="column-headquarters-3">
												<Form.Check inline label="Last-Mile Optimization" name="type_analysis" type='checkbox' id='lastmile' defaultChecked={(selection_distribution[1])} />
											</div>
											<div className="column-headquarters-1">
												<Form.Check inline label="Bicycle" name="type_analysis" type='checkbox' id='bike' defaultChecked={(selection_distribution[2])} />
											</div>
											<div className="column-headquarters-4">
												<Form.Check inline label="Working Time" name="type_analysis" type='checkbox' id='working' defaultChecked={(selection_distribution[3])} />
											</div>
										</div>
									</Form>
								</div>
							</div>
							{/* <div className="tile-employer-2d-filter">
								<div className="tile-employer-2d-filter-inner" onClick={() => this.hideComponentFilter()}>
									<IconContext.Provider value={{ color: "#5B5B5B", size: '1.8em' }}>
										<div>
											<ImEqualizer2 />
										</div>
									</IconContext.Provider>
								</div>
							</div> */}
							{(selectedPKm === 'pkm') ?
								<>
									{(selection_distribution[0] === true && selection_distribution[1] === false
										&& selection_distribution[2] === false && selection_distribution[3] === false)
										?
										<>
											<div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-1" style={{ top: "230px" }}>
												<div className="map-btn-tile-potential2D-resp-1-inner">
													<div className="row-parameters-3">
														<h3>{percentage_pkm_green}%</h3>
														<h4>of trips currently have a great car alternative</h4>
														<br />
														<br />
														<h4>Select measures to compute potential improvements</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-2" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-2-inner">
													<div className="row-parameters-3">
														<h3>{percentage_pkm_yellow}%</h3>
														<h4>of PKm currently have a decent car alternative</h4>
														<br />
														<br />
														<h4>Select measures to compute potential improvements</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-3" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-3-inner">
													<div className="row-parameters-3">
														<h3>{percentage_pkm_red}%</h3>
														<h4>of PKm currently have a bad car alternative</h4>
														<br />
														<br />
														<h4>Select measures to compute potential improvements</h4>
													</div>
												</div>
											</div>
										</>
										:
										<>
											<div className="map-potential-btn-tile-potential2D-resp-1" style={{ top: "230px" }}>
												<div className="map-btn-tile-potential2D-resp-1-inner">
													<div className="row-parameters-3">
														<h3>{percentage_pkm_statusquo_green}%</h3>
														<h4>of PKm currently have a decent car alternative</h4>
														<h3>{percentage_pkm_green}%</h3>
														<h4>of PKm would have a great car alternative with selected measures</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-2" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-2-inner">
													<div className="row-parameters-3">
														<h3>{percentage_pkm_statusquo_yellow}%</h3>
														<h4>of PKm currently have a decent car alternative</h4>
														<h3>{percentage_pkm_yellow}%</h3>
														<h4>of PKm would have a decent car alternative with selected measures</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-3" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-3-inner">
													<div className="row-parameters-3">
														<h3>{percentage_pkm_statusquo_red}%</h3>
														<h4>of PKm currently have a bad car alternative</h4>
														<h3>{percentage_pkm_red}%</h3>
														<h4>of PKm would still have a bad car alternative with selected measures</h4>
													</div>
												</div>
											</div>
										</>
									}
								</>
								:
								<>
									{(selection_distribution[0] === true && selection_distribution[1] === false
										&& selection_distribution[2] === false && selection_distribution[3] === false)
										?
										<>
											<div className="map-potential-btn-tile-potential2D-resp-1" style={{ top: "230px" }}>
												<div className="map-btn-tile-potential2D-resp-1-inner">
													<div className="row-parameters-3">
														<h3>{percentage_trips_green}%</h3>
														<h4>of trips currently have a great car alternative</h4>
														<br />
														<br />
														<h4>Select measures to compute potential improvements</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-2" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-2-inner">
													<div className="row-parameters-3">
														<h3>{percentage_trips_yellow}%</h3>
														<h4>of trips currently have a decent car alternative</h4>
														<br />
														<br />
														<h4>Select measures to compute potential improvements</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-3" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-3-inner">
													<div className="row-parameters-3">
														<h3>{percentage_trips_red}%</h3>
														<h4>of trips currently have a bad car alternative</h4>
														<br />
														<br />
														<h4>Select measures to compute potential improvements</h4>
													</div>
												</div>
											</div>
										</>
										:
										<>
											<div className="map-potential-btn-tile-potential2D-resp-1" style={{ top: "230px" }}>
												<div className="map-btn-tile-potential2D-resp-1-inner">
													<div className="row-parameters-3">
														<h3>{percentage_trips_statusquo_green}%</h3>
														<h4>of trips currently have a great car alternative</h4>
														<h3>{percentage_trips_green}%</h3>
														<h4>of trips would have a great car alternative with selected measures</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-2" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-2-inner">
													<div className="row-parameters-3">
														<h3>{ percentage_trips_statusquo_yellow}%</h3>
														<h4>of trips currently have a decent car alternative</h4>
														<h3>{percentage_trips_yellow}%</h3>
														<h4>of trips would have a decent car alternative with selected measures</h4>
													</div>
												</div>
											</div>
											<div className="map-potential-btn-tile-potential2D-resp-3" style={{ top: "410px" }}>
												<div className="map-btn-tile-potential2D-resp-3-inner">
													<div className="row-parameters-3">
														<h3>{ percentage_trips_statusquo_red}%</h3>
														<h4>of trips currently have a bad car alternative</h4>
														<h3>{percentage_trips_red}%</h3>
														<h4>of trips would still have a bad car alternative with selected measures</h4>
													</div>
												</div>
											</div>
										</>
									}
								</>
							}
						</>
						: <></>
					}
					{no_data ?
						<>
							<div className="modal-alert">
								<div className="modal-alert-inner">
									<h1>No data available</h1>
									<p>Please modify the current parameters and click again on <i>Evaluate potential</i></p>
								</div>
							</div>
						</>
						: <></>
					}
				</div>
			)
		}
	}
}

class MapPotential2D extends React.Component {

	// Set up states for updating map 
	constructor(props) {
		super(props);
		this.state = {
			lng: 8.251313,
			lat: 46.924143,
			zoom: 7,
			mapita: 9,
			tyle: 'mapbox://styles/mapbox/light-v10',
			hideNavs: false,
			initial_company: this.props.params,
			reli_company: [0, ''],
			change_of_background: 0
		}
	}

	//Update several fields
	updateFields(list) {
		this.setState(list);
	}

	updateField(card, value) {
		this.setState({
			...this.state,
			[card]: value
		});
	}

	//Update style
	handleTyle(value) {
		this.setState({ tyle: value, change_of_background: (this.state.change_of_background + 1) }, this.componentDidMount);
	}

	changeNameCompany(reli, current_company_name) {
		this.setState({ reli_company: [reli, (current_company_name === undefined ? '' : current_company_name)] })
	}

	//Update coordinates
	handleCoord(center, zoom) {
		const { lng, lat } = center;
		this.setState({ zoom: zoom, lat: lat, lng: lng })
	}

	componentDidMount() {
		// Set up map 
		const map = new mapboxgl.Map({
			container: this.mapContainer,
			style: this.state.tyle,
			center: [this.state.lng, this.state.lat],
			zoom: this.state.zoom,
		});

		map.on('load', () => {

			// Add zoom and rotation controls to the map.
			map.addControl(new mapboxgl.NavigationControl({ showCompass: false, showZoom: false }), 'top-left');
			map.addControl(new MapboxGeocoder({ accessToken: mapboxgl.accessToken, mapboxgl: mapboxgl, marker: false }), 'top-left');

			//Circles concentric
			//Add shapes to the map
			map.addSource('data-swiss-1km-tile', {
				'type': 'geojson',
				'data': lines_geojson,
				'generateId': true
			});

			map.addSource('data-swiss-100m-tile', {
				'type': 'geojson',
				'data': lines_geojson,
				'generateId': true
			});

			//Tyle visualization - 1km

			map.addLayer({
				'id': 'swiss-1km-tile',
				'type': 'fill',
				'source': 'data-swiss-1km-tile',
				'layout': {},
				'paint': {
					'fill-color': ['get', color_1km],
					'fill-opacity': 0.4
				}
			});

			map.addLayer({
				'id': 'outline-swiss-1km-tile',
				'type': 'line',
				'source': 'data-swiss-1km-tile',
				'layout': {},
				'paint': {
					'line-color': ['get', color_1km],
					'line-width': 1
				}
			});

			map.addLayer({
				'id': 'swiss-1km-tile-labels',
				'type': 'symbol',
				'source': 'data-swiss-1km-tile',
				"minzoom": 11,
				'layout': {
					'text-field': ['get', 'total_trips_weekdays_tiles'],
					'text-font': [
						'Open Sans Bold',
						'Arial Unicode MS Bold'
					],
					'text-size': 14,
					'text-transform': 'uppercase',
					'text-letter-spacing': 0.05,
					'text-offset': [0, 1],
					'visibility': 'visible'
				}
			});


			//Tyle visualization - 100m

			map.addLayer({
				'id': 'swiss-100m-tile',
				'type': 'fill',
				'source': 'data-swiss-100m-tile',
				'layout': {},
				'paint': {
					'fill-color': '#9E2E6A',
					'fill-opacity': 0.4
				}
			});

			map.addLayer({
				'id': 'outline-swiss-100m-tile',
				'type': 'line',
				'source': 'data-swiss-100m-tile',
				'layout': {},
				'paint': {
					'line-color': '#9E2E6A',
					'line-width': 1
				}
			});

			//Tyle selected - 1km
			map.addSource('data-selected-tile', {
				'type': 'geojson',
				'data': {
					"type": "FeatureCollection",
					"features": []
				},
				'generateId': true
			});

			map.addLayer({
				'id': 'selected-tile',
				'type': 'fill',
				'source': 'data-selected-tile',
				'layout': {},
				'paint': {
					'fill-color': '#51aea1',
					'fill-opacity': 0.2
				}
			});

			map.addLayer({
				'id': 'outline-selected-tile',
				'type': 'line',
				'source': 'data-selected-tile',
				'layout': {},
				'paint': {
					'line-color': '#51aea1',
					'line-width': 1
				}
			});

			// Add circle 
			map.addSource('point', {
				'type': 'geojson',
				'data': lines_geojson
			});

			map.addLayer({
				'id': 'point',
				'type': 'circle',
				'source': 'point',
				'paint': {
					'circle-radius': 10,
					'circle-color': ['get', 'color'] // blue color
				}
			});

		});

		this.setState({
			mapita: map,
			zoom: map.getZoom(),
			center: map.getCenter(),
		});

		map.on('click', 'point', (e) => {
			let html = '<p style="margin-block-end: 0em;"><span style="font-weight: bold;">' + (e.features[0].properties.company_name === undefined ? 'Name not available' : e.features[0].properties.company_name) + '</span><br/><span style="font-weight: bold;">Building Category: </span>' + e.features[0].properties.main_category.charAt(0).toUpperCase() + e.features[0].properties.main_category.slice(1) + '<br/><span style="font-weight: bold;">Number of employees: </span>' + numberWithCommas(e.features[0].properties.total_employees) + '</p>';
			this.changeNameCompany(e.features[0].properties.RELI, e.features[0].properties.company_name)

			new mapboxgl.Popup()
				.setLngLat(e.lngLat)
				.setHTML(html).addTo(map);
		})

		// Fullscreen map 
		//map.addControl(new mapboxgl.FullscreenControl());
		map.on('click', 'swiss-1km-tile', (e) => {
			if (e.features[0].properties.tileId !== employer) {
				console.log(e.features[0].properties.tileId)
				let resp_data = e.features[0].properties

				let total_trips_weekdays_tiles = (resp_data.total_trips_weekdays_tiles).toFixed(0)
				let duration_car_text = resp_data.duration_car_text
				let duration_train_text = resp_data.duration_train_text
				let geodesic_distance_m = (resp_data.geodesic_distance_m).toFixed(0)

				let car_trips_weekdays_tiles = (resp_data.car_trips_weekdays_tiles === null ? 0 : resp_data.car_trips_weekdays_tiles);
				let train_trips_weekdays_tiles = (resp_data.train_trips_weekdays_tiles === null ? 0 : resp_data.train_trips_weekdays_tiles);
				let foot_trips_weekdays_tiles = (resp_data.foot_trips_weekdays_tiles === null ? 0 : resp_data.foot_trips_weekdays_tiles);
				let tram_trips_weekdays_tiles = (resp_data.tram_trips_weekdays_tiles === null ? 0 : resp_data.tram_trips_weekdays_tiles);
				let bike_trips_weekdays_tiles = (resp_data.bike_trips_weekdays_tiles === null ? 0 : resp_data.bike_trips_weekdays_tiles);
				let bus_trips_weekdays_tiles = (resp_data.bus_trips_weekdays_tiles === null ? 0 : resp_data.bus_trips_weekdays_tiles);
				let ubahn_trips_weekdays_tiles = (resp_data.ubahn_trips_weekdays_tiles === null ? 0 : resp_data.ubahn_trips_weekdays_tiles);
				let motorbike_trips_weekdays_tiles = (resp_data.motorbike_trips_weekdays_tiles === null ? 0 : resp_data.motorbike_trips_weekdays_tiles);

				console.log(total_trips_weekdays_tiles)

				let html = '<table style="margin:auto; table-layout:fixed; padding:0px; text-align:center; vertical-align:middle;"><tbody><tr><th>Total trips during weekdays per day</th></tr><tr><td>' + total_trips_weekdays_tiles + '</td></tr><tr><th>Duration in car</th></tr><tr><td>' + duration_car_text + '</td><tr><th>Duration in public transport</th></tr><tr><td>' + duration_train_text + '</td><tr><th>Distance in meters</th></tr><tr><td>' + numberWithCommas(geodesic_distance_m) + 'm</td></tr></tbody></table><h3 style="margin-block-start:0px; margin-block-end:0px;">Trips per Mode of Transport</h3><table style="margin:auto; table-layout:fixed; padding:0px; text-align:center; vertical-align:middle;"><thead><tr><th></th><th>Trips/day</th><th>Modal Split</th></tr></thead><tbody><tr><th>Trains</th><td>' + (train_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (train_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>Cars</th><td>' + (car_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (car_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>Foot</th><td>' + (foot_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (foot_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>Tram</th><td>' + (tram_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (tram_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>Bike</th><td>' + (bike_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (bike_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>Bus</th><td>' + (bus_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (bus_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>UBahn</th><td>' + (ubahn_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (ubahn_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><tr><th>Motorbike</th><td>' + (motorbike_trips_weekdays_tiles).toFixed(0) + '</td><td>' + (motorbike_trips_weekdays_tiles / total_trips_weekdays_tiles * 100).toFixed(0) + '%</td></tr><hr/><tr><th>Total:</th><td>' + (total_trips_weekdays_tiles) + '</td><td>-</td></tr></tbody></table>';

				new mapboxgl.Popup()
					.setLngLat(e.lngLat)
					.setHTML(html).addTo(map);
			}
		});
	}

	render() {
		const { hideNavs } = this.state;

		return (
			<div>
				<div ref={el => this.mapContainer = el} style={{ width: '100%', height: '100vh' }}>
				</div>
				<RecommendationNavBarComponent />
				<HideElementsComponent map={this.state.mapita} updateField={(card, field, value) => this.updateField(card, field, value)} />
				<div style={{ display: hideNavs ? 'none' : 'block' }}>
					<BtnsComponent map={this.state.mapita} updateFields={(list) => this.updateFields(list)} initial_company={this.state.initial_company} reli_company={this.state.reli_company} change_of_background={this.state.change_of_background} />
				</div>
				<LayerTylesComponent map={this.state.mapita} tyle={this.state.tyle} handleTyle={(value) => this.handleTyle(value)} handleCoord={(value1, value2) => this.handleCoord(value1, value2)} />
			</div>
		)
	}
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => (
	<MapPotential2D
		{...props}
		params={useParams()}
	/>
); 